export interface AlainErrorCollectConfig {
  /**
   * çå¬é¢çï¼é»è®¤ï¼`500`
   */
  freq?: number;
  /**
   * é¡¶é¨åç§»å¼ï¼é»è®¤ï¼`145`
   */
  offsetTop?: number;
}
